module.exports = __webpack_public_path__ + "img/11_43.3d7ef935.png";